import React from 'react';
import * as XLSX from 'xlsx';

const JunctionBoxPottingMaterial = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const pottingData = inspectionData.JunctionBoxPottingMaterial;

  if (!pottingData || !pottingData.lines) {
    return <p className="text-gray-500">No Junction Box Potting Material data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Date',
      'Shift',
      'Line',
      'A Glue',
      'B Glue',
      'Total Glue',
      'Ratio',
      'Make',
      'Time',
      'Remark',
    ]);

    // Populate data for each line
    Object.entries(pottingData.lines).forEach(([lineKey, lineData]) => {
      worksheetData.push([
        pottingData.date,
        pottingData.shift,
        lineKey,
        lineData.aGlue,
        lineData.bGlue,
        lineData.totalGlue,
        lineData.ratio,
        lineData.make,
        lineData.time,
        lineData.remark,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'JunctionBoxPotting');
    XLSX.writeFile(workbook, 'JunctionBoxPottingMaterialData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">
          Junction Box Potting Material - {pottingData.date} ({pottingData.shift})
        </h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      <div className="overflow-x-auto">
        <table className="min-w-full bg-white border rounded-lg">
          <thead>
            <tr className="bg-gray-100">
              <th className="px-4 py-2 text-left text-gray-700">Line</th>
              <th className="px-4 py-2 text-left text-gray-700">A Glue</th>
              <th className="px-4 py-2 text-left text-gray-700">B Glue</th>
              <th className="px-4 py-2 text-left text-gray-700">Total Glue</th>
              <th className="px-4 py-2 text-left text-gray-700">Ratio</th>
              <th className="px-4 py-2 text-left text-gray-700">Make</th>
              <th className="px-4 py-2 text-left text-gray-700">Time</th>
              <th className="px-4 py-2 text-left text-gray-700">Remark</th>
            </tr>
          </thead>
          <tbody>
            {Object.entries(pottingData.lines).map(([lineKey, lineData]) => (
              <tr key={lineKey} className="border-t">
                <td className="px-4 py-2 text-gray-600">{lineKey}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.aGlue || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.bGlue || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.totalGlue || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.ratio || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.make || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.time || 'N/A'}</td>
                <td className="px-4 py-2 text-gray-600">{lineData.remark || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default JunctionBoxPottingMaterial;